import { gql } from 'apollo-boost';

export const BUSINESS_GROUP_BY_ID_GQL = gql`
  query BusinessGroupById($id: ID!) {
    business_group(id: $id) {
      id
      name
      created_at
      updated_at
      businesses {
        id
        name
      }
    }
  }
`;
